import appProzis from '@/Utilities/app-prozis-store';
import request from '@/Utilities/httpRequest';
import baseUrl from "@/api/base-url";
import browser from "@/Utilities/browser";
import utilsHeader from '@/Utilities/desktop-header';

export enum SocialLikesType{
    MENTION = 'SC_MENTION_ID',
    PROFILE = 'SC_FOLLOW_PROFILE_ID',
    COMMENT = 'SC_COMMENT_MENTION_ID',
}

export class SocialLikes{
    protected _num: number;
    protected _numFormatted?: string;
    protected _liked: boolean;
    protected _type?: SocialLikesType;
    protected _id?: string;
    protected _showNum: boolean = true;

    public constructor(num: number, liked: boolean){
        this._liked = liked;
        this._num = num;
    }

    //Likes count
    public get num(): number {return this._num > 0 ? this._num : 0; }
    public set num(value: number) { this._num = value; }

    //Likes count formatted
    public get numFormatted(): string|undefined {return this._numFormatted; }
    public set numFormatted(value: string|undefined) { this._numFormatted = value; }

    //Customer liked
    public get liked(): boolean {return this._liked; }
    public set liked(value: boolean) {this._liked = value; }

    //Like ID (of element)
    public get id(): string|undefined {return this._id; }
    public set id(value: string) { this._id = value; }

    //Like ID (of element)
    public get type(): SocialLikesType|undefined {return this._type; }
    public set type(value: SocialLikesType) { this._type = value; }


    //Show likes number
    public get showNum(): boolean {return this._showNum; }
    public set showNum(value: boolean) {this._showNum = value; }

    /**
     * Call the backend for add or remove the like
     * 
     * @returns 
     */
    public async click() {
        if(!this.id || !this.type){
            return false;
        }
        let action = this.liked ? 'likes/remove' : 'likes/add';

        const params: any = {
            id: this.id,
            type: this.type,
            url:  document.location.href ?? null,
        }
        const {data} = await request.get(baseUrl.getUrl(action), params, false);

        if(data.redirect){
            document.location = data.redirect;
            return false;
        }

        if(data.redirect){
            document.location = data.redirect;
        }
        else if(data.doAuth){
            // desktop has tricky modal for login
            let w = (window as any);
            if(typeof w.accountAuth !== 'undefined'){
                // open login modal 
                w.accountAuth.openLogin(data.urlParams);
            } else {
                utilsHeader.sendHeaderEvent('evtOpenLogin', {open: true, params: data.urlParams});
            }
        }
        else{
            if(browser.isApp()){
                let c = this._num + (data.liked ? 1 : -1);
                appProzis.call('updateLike',JSON.stringify({
                    type: this.type,
                    id: this.id ?? null,
                    customerHasLike: data.liked,
                    count: c
                }));
            }
        }

        if(data?.hasError ?? false){
            return false;
        }
        let oldLiked = this.liked;
        this.liked = (data.liked ?? false);
        if(oldLiked != this.liked){
            this.liked ? this.num++ : this.num--;
        }
        return true;
    }

    /**
     * Returns the object to call the backend
     * 
     * @returns object
     */
    public params(): object{
        return {
            itemId: this.id,
            type: this.type,
            liked: this.liked
        }
    }
}